const faqItems = [
  {
    id: 1,
    q: '宅男视频需要注册才能观看吗？',
    a: '完全不需要！宅男视频所有内容均可免费直接观看，无需注册、无需登录。我们坚持开放访问的理念，让你打开就能看，省去一切繁琐步骤。',
  },
  {
    id: 2,
    q: '支持哪些视频平台的内容？',
    a: '目前宅男视频已聚合香蕉视频、红桃视频、蜜桃视频和樱花视频四大热门平台的内容资源，覆盖动作、悬疑、综艺、动漫、午夜等多个品类。更多平台正在持续接入中。',
  },
  {
    id: 3,
    q: '视频画质怎么样？会不会卡顿？',
    a: '全站视频均支持高清播放，我们采用先进的视频加速和 CDN 分发技术，确保加载速度和播放流畅度。建议在网络良好的环境下观看以获得最佳体验。',
  },
  {
    id: 4,
    q: '内容更新频率如何？',
    a: '我们的内容团队 7×24 小时不间断运营，每日更新超过 2000 部视频资源。热门榜单和最新上线实时同步各平台更新，确保你每次打开都有新鲜内容。',
  },
  {
    id: 5,
    q: '观看视频安全吗？会不会泄露隐私？',
    a: '宅男视频高度重视用户隐私安全。全站采用 HTTPS 加密传输，无需注册即可观看，不收集任何个人信息。我们也没有烦人的弹窗广告，给你一个干净安全的观影环境。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">常见问题</h2>
        <p className="section-subtitle">关于宅男视频的常见疑问，这里为你一一解答</p>
        <div className="mt-10 max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0 text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-9">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}